import React, { useEffect, useRef, useState } from "react";
import { Button, FormLabel, FormElement, FormInput, CancelButton } from "../../../../../components/StyledElements";
import { RejectionBlock } from "../../../../../components/RejectionBlock";
import swal from "sweetalert2";
import { updateContentBlock, checkForContentBlockSpeechURL, deleteBlock } from "../../../../../services/courses";
import { Icon } from "@iconify/react";

export const EditContent = ({ levelSection, courseId, onUpdateContent = () => { }, style = {} }) => {

  const containerRef = useRef(null);

  const [currentBlockIndex, setCurrentBlockIndex] = useState(0);
  const [currentBlock, setCurrentBlock] = useState();
  const [updatedBlock, setUpdatedBlock] = useState();
  const [savingBlock, setSavingBlock] = useState(false);

  const checkUpdatedSpeechIntervalRef = useRef(null);
  //
  //  
  useEffect(() => {
    console.log("CONTAINER REF: ", containerRef.current);
    const r = window.addEventListener("resize", () => {
      if (containerRef.current) {
        const newContainerWidth = containerRef.current.getBoundingClientRect().width;
        const offset = (currentBlockIndex + 1) * (newContainerWidth + 10);
        containerRef.current.scrollTo({ left: offset, behavior: "smooth" });
      }
    });

    return () => {
      window.removeEventListener("resize", r);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (checkUpdatedSpeechIntervalRef.current) {
      clearInterval(checkUpdatedSpeechIntervalRef.current);
    }

    if (levelSection?.content_blocks) {
      const currentBlock = levelSection.content_blocks[currentBlockIndex];
      setCurrentBlock(currentBlock);
      setUpdatedBlock(currentBlock);

      if (!currentBlock?.speech_url && currentBlock?.needs_speech_updated) {
        // check every 60 seconds if the speech_url has been updated   
        const fetchUpdatedBlockSpeechURL = async () => {
          if (checkUpdatedSpeechIntervalRef.current) {
            clearInterval(checkUpdatedSpeechIntervalRef.current);
          }

          const results = await checkForContentBlockSpeechURL(currentBlock.public_id);
          if (results?.speech_url) {
            const newUpdatedBlock = { ...updatedBlock };
            newUpdatedBlock.speech_url = results.speech_url;
            newUpdatedBlock.needs_speech_updated = false;
            setUpdatedBlock(newUpdatedBlock);
            clearInterval(checkUpdatedSpeechIntervalRef.current);
            return;
          }

          checkUpdatedSpeechIntervalRef.current = setInterval(async () => {
            const results = await checkForContentBlockSpeechURL(currentBlock.public_id);
            if (results?.speech_url) {
              const newUpdatedBlock = { ...updatedBlock };
              newUpdatedBlock.speech_url = results.speech_url;
              newUpdatedBlock.needs_speech_updated = false;
              setUpdatedBlock(newUpdatedBlock);
              clearInterval(checkUpdatedSpeechIntervalRef.current);
            }
          }, 60000);
        }

        fetchUpdatedBlockSpeechURL();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentBlockIndex, levelSection?.content_blocks]);

  useEffect(() => {
    // Get the current hash from the URL and set the current block accordingly
    if (!levelSection?.content_blocks || levelSection.content_blocks.length === 0) {
      return;
    }

    const hash = window.location.hash;
    const parts = hash.split("&");
    console.log("!!! pARTS: ", parts);
    if (parts.length > 0 && parts[0] === "#content") {
      if (parts && parts.length > 1) {
        if (!parts[1].match(/^\d+$/)) {
          const blockIndex = levelSection.content_blocks.findIndex((b) => b.public_id === parts[1]);
          if (blockIndex !== -1) {
            setCurrentBlockIndex(blockIndex);
            const offset = blockIndex * (containerRef.current.getBoundingClientRect().width + 10);
            containerRef.current.scrollTo({ left: offset });
            return;
          } else {
            console.log("!!! BLOCK NOT FOUND: ", parts[1]);
          }
        }
        const blockIndex = parseInt(parts[1]);
        console.log("!!! BLOCK INDEX: ", blockIndex);
        if (!isNaN(blockIndex) && blockIndex > 0 && blockIndex <= levelSection?.content_blocks?.length) {
          setCurrentBlockIndex(blockIndex - 1);
          const offset = (blockIndex - 1) * (containerRef.current.getBoundingClientRect().width + 10);
          containerRef.current.scrollTo({ left: offset });
        }
      } else {
        console.log("!!! CHANGING TO CONTENT 1")
        window.history.replaceState(null, null, `#content&1`);
        setCurrentBlockIndex(0);
        containerRef.current.scrollTo({ left: 0 });
      }
    }
  }, [levelSection?.content_blocks]);

  const getRemoteURL = (path) => {
    if (!path.match(/^(https?:|blob:|data:)/)) {
      const parts = path.split("/");
      const filename = parts.pop();
      return `https://az.agentwire.ai/content/course_assets/${courseId}/${filename}`;
    }
    return path;
  };

  const hasChanged = () => {
    if (!currentBlock || !updatedBlock) {
      return false;
    }
    return updatedBlock.image_data || currentBlock.short_title !== updatedBlock.short_title || currentBlock.content !== updatedBlock.content;
  }

  const handleImageSelected = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const dataURL = e.target.result;          // "data:image/png;base64,iVBOR..."
      setUpdatedBlock((prev) => ({
        ...prev,
        image: { ...(prev?.image ?? {}), path: dataURL },  // preview + payload, same string
        image_data: {
          base64_data: dataURL.split(",")[1],  // only base64 part for payload
          filename: file.name,
        },
      }));
    };
    reader.readAsDataURL(file);
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", ...style }}>
        <div style={{ position: "absolute", top: 20, right: 20, display: "flex", zIndex: 200, flexDirection: "row", gap: "10px" }}>
          <CancelButton onClick={() => {
            swal.fire({
              title: "Are you sure?",
              text: "Any unsaved changes will be lost.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, cancel",
              cancelButtonText: "No, keep editing",
            }).then((result) => {
              console.log("!!! RESULT: ", result);
              if (result?.value) {
                setUpdatedBlock(currentBlock);
              }
            });
          }}>Cancel</CancelButton>
          <Button disabled={!hasChanged() || savingBlock} style={{ marginLeft: "auto" }}
            onClick={async () => {
              if (!hasChanged()) {
                return;
              }


              // open a sweetalert2 modal until the save is complete
              swal.fire({
                title: "Saving...",
                text: "Please wait while the content block is being saved.",
                allowOutsideClick: false,
                didOpen: () => {
                  swal.showLoading();
                },
              });

              setSavingBlock(true);
              const results = await updateContentBlock(updatedBlock);
              setSavingBlock(false);

              if (results.success) {
                //const newUpdatedBlock = results.content_block;
                setCurrentBlock(updatedBlock);
                onUpdateContent({ ...results.content_block });

                swal.fire({
                  title: "Success",
                  text: "Content block saved successfully.",
                  icon: "success",
                });
              } else {
                swal.fire({
                  title: "Error",
                  text: results.error || "An error occurred while saving the content block.",
                  icon: "error",
                });
              }
            }}
          >
            {savingBlock ? "Saving Content Block..." : "Save Content Block"}
          </Button>
        </div>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
          <FormLabel label={`Content Block ${currentBlockIndex + 1} of ${levelSection?.content_blocks?.length}`} />
          {
            updatedBlock?.speech_url ? (
              <audio src={updatedBlock.speech_url} controls style={{ width: "250px", marginLeft: "auto", marginBottom: "10px", height: "20px" }} />
            ) : (
              <div style={{ width: "250px", marginBottom: "10px", height: "20px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {updatedBlock?.needs_speech_updated ? (
                  <span style={{ color: "var(--main-font-color)" }}>Generating speech...</span>
                ) : (
                  <span style={{ color: "var(--main-font-color)" }}>No speech available</span>
                )}
              </div>
            )
          }
          <div style={{ marginLeft: "auto", display: "flex", flexDirection: "row", gap: "10px" }}>
            <Icon icon="mdi:delete" height={20} width={20} style={{ cursor: "pointer", color: "var(--error-color)" }} onClick={() => {
              swal.fire({
                title: "Are you sure?",
                text: "This will delete the current block. This action cannot be undone.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it",
                cancelButtonText: "No, keep it",
              }).then(async (result) => {
                if (result?.value) {
                  const results = await deleteBlock(currentBlock.public_id);
                  if (results.success) {
                    swal.fire({
                      title: "Deleted!",
                      text: "The content block has been deleted.",
                      icon: "success",
                    });
                    // Remove the block from the levelSection.quiz.blocks array
                    onUpdateContent({ ...currentBlock }, true);
                  } else {
                    swal.fire({
                      title: "Error",
                      text: results.error || "An error occurred while deleting the block.",
                      icon: "error",
                    });
                  }
                }
              });
            }} />
          </div>
        </div>
        <RejectionBlock contentPublicId={currentBlock?.public_id} />

        <FormElement>
          <FormInput value={updatedBlock?.public_id ?? ""} style={{ backgroundColor: "white" }} disabled />
        </FormElement>

        <FormElement>
          <FormInput value={updatedBlock?.short_title ?? ""}
            onChange={(e) => {
              const newBlock = { ...updatedBlock };
              newBlock.short_title = e.target.value;
              setUpdatedBlock(newBlock);
            }}
          />
        </FormElement>


        <div ref={containerRef} id="content-blocks-container" style={{ width: "100%", marginBottom: "10px", overflow: "hidden" }}>
          <div style={{ display: "flex", flexDirection: "row", marginBottom: "10px", flowWrap: "nowrap" }}>
            {/*Each content block will be displayed as it's own page, and the wrapper will scroll horizontally to show the next content block*/}
            {levelSection?.content_blocks?.map((block, index) => {
              const isCurrent = index === currentBlockIndex;
              const blockData = isCurrent ? updatedBlock : block;
              const imgPath = blockData?.image?.path ? getRemoteURL(blockData.image.path) : null;

              return (
                <FormElement key={index} style={{ flex: "0 0 100%", marginRight: "10px" }}>
                  <div style={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    {imgPath ? (
                      <img src={imgPath} alt="content block" style={{ height: "200px", width: "auto", marginBottom: "10px" }} />
                    ) : null}

                    {isCurrent && (
                      <div className="field" style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
                        <label className="upload-link" htmlFor={`fileInput-${index}`} style={{ cursor: "pointer" }}>
                          {imgPath ? "Update Image" : "Add Image"}
                        </label>
                        <input
                          type="file"
                          id={`fileInput-${index}`}
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={(e) => handleImageSelected(e.target.files[0])}
                        />
                      </div>
                    )}
                  </div>


                  <FormInput
                    as="textarea"
                    value={blockData?.content ?? ""}
                    readOnly={!isCurrent}
                    style={{ width: "100%", height: "350px", resize: "vertical" }}
                    onChange={isCurrent ? (e) => {
                      const newBlock = { ...updatedBlock };
                      newBlock.content = e.target.value;
                      setUpdatedBlock(newBlock);
                    } : null}
                  />
                </FormElement>
              );
            })}
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
          {currentBlockIndex > 0 ? (
            <Button style={{ justifySelf: "flex-start" }} onClick={() => {
              const width = containerRef.current.getBoundingClientRect().width;
              const offset = (currentBlockIndex - 1) * (width + 10);
              setCurrentBlockIndex(currentBlockIndex - 1);
              containerRef.current.scrollTo({ left: offset, behavior: "smooth" });
              window.history.replaceState(null, null, `#content&${currentBlockIndex - 1}`);
            }}>Previous</Button>
          ) : null}
          {
            currentBlockIndex < levelSection?.content_blocks?.length - 1 ? (
              <Button style={{ justifySelf: "flex-end", marginLeft: "auto" }} onClick={() => {
                const width = containerRef.current.getBoundingClientRect().width;
                const offset = (currentBlockIndex + 1) * (width + 10);
                setCurrentBlockIndex(currentBlockIndex + 1);
                containerRef.current.scrollTo({ left: offset, behavior: "smooth" });
                // Update the current url hash to reflect the current content block
                window.history.replaceState(null, null, `#content&${currentBlockIndex + 2}`);
              }}>Next</Button>) : null}
        </div>
      </div>
    </>
  )
}

export default EditContent;
